// IVA (VAT) — normativa italiana B2C.
// I prezzi in tutto il sistema sono NETTI. Il cliente paga il LORDO
// (IVA inclusa = netto × 1,22). Imponibile e IVA sono ricavati a ritroso
// (scorporo) dal totale finale già IVA inclusa: imponibile = totale / 1,22.
export const VAT_RATE = 0.22;

// Arrotondamento commerciale al centesimo (metà in su sul valore decimale):
// identico a vat_service.r2 del backend, così carrello e Stripe coincidono.
export const roundMoney = (n) => {
  const x = Number(n) || 0;
  let s = String(Math.abs(x));
  if (s.includes("e")) s = Math.abs(x).toFixed(20);
  const [int, frac = ""] = s.split(".");
  const f = `${frac}000`.slice(0, 3);
  const cents = Number(int) * 100 + Number(f.slice(0, 2)) + (Number(f[2]) >= 5 ? 1 : 0);
  return (Math.sign(x) * cents) / 100 || 0;
};
const r2 = roundMoney;

// Calcoli IVA esatti in centesimi interi (metà in su), identici a vat_service.py.
const RATE_PCT = Math.round((1 + VAT_RATE) * 100); // 122
const cents = (n) => Math.round(r2(n) * 100);
const sign = (n) => (Number(n) < 0 ? -1 : 1);

// Netto → lordo (IVA inclusa)
export const toGross = (net) => (sign(net) * Math.floor((Math.abs(cents(net)) * RATE_PCT + 50) / 100)) / 100 || 0;

// Lordo → netto (scorporo)
export const toNet = (gross) => (sign(gross) * Math.floor((Math.abs(cents(gross)) * 200 + RATE_PCT) / (2 * RATE_PCT))) / 100 || 0;

// Scorpora un totale IVA inclusa in { gross, taxable (imponibile), vat }
export const vatBreakdown = (gross) => {
  const g = cents(gross);
  const t = Math.floor((g * 200 + RATE_PCT) / (2 * RATE_PCT));
  return { gross: g / 100, taxable: t / 100, vat: (g - t) / 100 };
};
